function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "a",
  d: "M14.963.13v15.31H.01V.13h14.953z"
}), React.createElement("path", {
  id: "c",
  d: "M.026.141h12.5v4.465H.026V.14z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(17.919 8.42)"
}, React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#a"
})), React.createElement("path", {
  d: "M7.487 3.659c-2.223 0-4.03 1.85-4.03 4.126 0 2.275 1.807 4.126 4.03 4.126 2.222 0 4.03-1.85 4.03-4.126 0-2.275-1.808-4.126-4.03-4.126m0 11.78C3.364 15.44.01 12.006.01 7.785.01 3.565 3.364.131 7.487.131c4.122 0 7.476 3.433 7.476 7.654 0 4.22-3.354 7.654-7.476 7.654",
  fill: "currentColor",
  mask: "url(#b)"
})), React.createElement("path", {
  d: "M7.477 12.078c-2.222 0-4.03 1.85-4.03 4.126 0 2.275 1.808 4.126 4.03 4.126 2.223 0 4.03-1.85 4.03-4.126 0-2.275-1.807-4.126-4.03-4.126m0 11.78C3.354 23.859 0 20.426 0 16.205c0-4.22 3.354-7.655 7.477-7.655s7.477 3.434 7.477 7.655c0 4.22-3.354 7.655-7.477 7.655M13.033 6.534H7.006c-.956 0-1.73-.793-1.73-1.771 0-.978.774-1.771 1.73-1.771h6.027c.956 0 1.73.793 1.73 1.77 0 .979-.774 1.772-1.73 1.772",
  fill: "currentColor"
}), React.createElement("g", {
  transform: "translate(17.321 .011)"
}, React.createElement("mask", {
  id: "d",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#c"
})), React.createElement("path", {
  d: "M6.261 4.606a13.07 13.07 0 0 1-5.177-1.06C.206 3.17-.207 2.136.16 1.237A1.71 1.71 0 0 1 2.415.291a9.71 9.71 0 0 0 3.846.787A9.713 9.713 0 0 0 10.133.28a1.709 1.709 0 0 1 2.257.94c.37.898-.041 1.933-.918 2.312a13.072 13.072 0 0 1-5.21 1.074",
  fill: "currentColor",
  mask: "url(#d)"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 33 24",
    width: 33,
    height: 24,
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.07252132.svg";
export { ForwardRef as ReactComponent };